// Generated by purs version 0.13.0
"use strict";
var Data_Eq = require("../Data.Eq/index.js");
var Data_Show = require("../Data.Show/index.js");
var Up = (function () {
    function Up() {

    };
    Up.value = new Up();
    return Up;
})();
var Down = (function () {
    function Down() {

    };
    Down.value = new Down();
    return Down;
})();
var Left = (function () {
    function Left() {

    };
    Left.value = new Left();
    return Left;
})();
var Right = (function () {
    function Right() {

    };
    Right.value = new Right();
    return Right;
})();
var showDirection = new Data_Show.Show(function (v) {
    if (v instanceof Up) {
        return "Up";
    };
    if (v instanceof Down) {
        return "Down";
    };
    if (v instanceof Left) {
        return "Left";
    };
    if (v instanceof Right) {
        return "Right";
    };
    throw new Error("Failed pattern match at Chip.Model.Direction (line 17, column 10 - line 21, column 21): " + [ v.constructor.name ]);
});
var eqDirection = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Up && y instanceof Up) {
            return true;
        };
        if (x instanceof Down && y instanceof Down) {
            return true;
        };
        if (x instanceof Left && y instanceof Left) {
            return true;
        };
        if (x instanceof Right && y instanceof Right) {
            return true;
        };
        return false;
    };
});
module.exports = {
    Up: Up,
    Down: Down,
    Left: Left,
    Right: Right,
    eqDirection: eqDirection,
    showDirection: showDirection
};
